import React from 'react'
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";


const leftSidedImageCopyItemCollectionData = [
    {
        description : [
            'With an initial design brief to create multiple areas to entertain and relax the entire site was cleared in preparation for the main structural elements of stone walling, precast concrete steps and hardwood timber decking. The scale of this home allowed for very generous areas of decking and lawn with large sweeping curves providing the necessary depth for multiple layers of lush planting.',
            'The large rooftop area not only provides a private retreat but also an opportunity to appreciate the overall design and scale of the garden.',
            'Interest was generated through multiple layers of planting and many leaf shapes and colours. The soothing mid greens of the large lawn area provides the necessary balance to the various combination of surfaces and materials.',
            'Contemporary white cylinders allow the planting to further soften the generous home and complementing the contemporary white furnishings.'
        ],
        descriptionContent : (
          <p>
          <span className="line">
          <b>Services Undertaken</b>
          <br />Landscape Design
          <br />Construction
          </span>
          
          <b>Design Features</b>
          <br />Contemporary
          <br />Family
          <br />Entertainer
          <br />Classic
          <br />Courtyard/Rooftop
          </p>
        ),
        image : '../images/projects/earlwood-7.jpg',
        title : 'Earlwood'
    }
]

const projectImageDetailPageCollectionData = [
    {
        dataId : 'a1',
        image : '../images/projects/earlwood-1.jpg'
    },
    {
        dataId : 'a8',
        image : '../images/projects/earlwood-2.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/earlwood-3.jpg'
    },
    {
        dataId : 'a4',
        image : '../images/projects/earlwood-4.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/earlwood-5.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/earlwood-6.jpg'
    },
    {
        dataId : 'a4',
        image : '../images/projects/earlwood-7.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/earlwood-8.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/earlwood-9.jpg'
    },
]

const PageEarlwood = () => {
  return (
    <LayoutMain>
          <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
        </LayoutMain>
  )
}

export default PageEarlwood